export const SERVICE_START=``;
export const SERVICE_INPROGRESS =`LOADING`;
export const SERVICE_COMPLETE=``;

export const serviceInProgress=(params)=>({
    type:SERVICE_INPROGRESS,
    value:params,
    });
    